export const EDIT_PROFILE_TITLE = "Here you can edit your profile";

export const FIRST_NAME_TITLE = "First Name";
export const FIRST_NAME = "FirstName";

export const LAST_NAME_TITLE = "Last Name";
export const LAST_NAME = "LastName";

export const COMPANY_NAME_TITLE = "Company";
export const COMPANY_NAME = "CompanyName";

export const ACCOUNT_NAME = "Account";

export const EMAIL_ADDRESS_NAME_TITLE = "Email address";
export const EMAIL_ADDRESS_NAME = "Email";

export const PHONE_NAME_TITLE = "Phone Number";
export const PHONE_NAME = "PhoneNumber";

export const COUNTRY_CODE_TITLE = "Country Code";